import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr";
import FlatpickrShortcuts from "shortcut-buttons-flatpickr";
import $ from 'jquery';
import { Modal } from "bootstrap"
import { getDateFromRelativeDate, getModal } from "../helpers";

export default class extends Controller {
  static targets = [
    "offcanvasTimeline",
    "offcanvasTimelineSidebar",
    "dropdownStatus",
    "datepicker",
    "sendAsvBtn",
    "timepicker",
    "submitBtnDateTime",
    "referredProviderDropdownMenu",
    "appointmentType",
    "closeReferral",
    "inputLocation",
    "hiddenInputLocationId",
    "locationDropdown",
    "locationDropdownItems",
    "inputProvider",
    "hiddenInputProviderId",
    "providerDropdown",
    "providerDropdownItems",
    "datetimepicker",
    "notice",
    "unscheduleCheckbox",
    "hiddenInputAcceptReferral",
    "onHoldReminder",
    "customSnoozeReminder",
    "modalCompletedDialog"
  ]

  connect() {
    $("tr[data-link]").click(function () {
      $.ajax({
        dataType: "script",
        url: $(this).data("link"),
      });
    });

    if (this.hasTimepickerTarget) {
      this.populateTimepicker();
      $(this.timepickerTarget).val(this.timepickerTarget.dataset.value)
    }

    if (this.hasDatepickerTarget) {
      this.initDatepicker();
    }
    if (this.hasAppointmentStatusTarget) {
      const selectedValue = this.appointmentTypeTarget.dataset.value;

      const radioButtons = this.appointmentTypeTarget.querySelectorAll('input[type="radio"]');
      radioButtons.forEach(radio => {
        if (radio.value === selectedValue) {
          radio.checked = true;
        }

        radio.addEventListener('change', () => {
          this.checkDateTimeSelected();
        });
      });
    }

    if (this.hasDatetimepickerTarget) {
      this.initDatetimepicker();
    }

    document.addEventListener("click", this.closeDropdowns.bind(this));

    this.checkForModalOpen();
    
   
  }

  onHoldReminderTargetConnected(ee) {
    $(this.onHoldReminderTarget).on('click', '.dropdown-menu li', (e) => {
      const relativeReminder = e.target.dataset.onholdReminder
      this.toggleOnHoldReminder(relativeReminder)
    })
  }

  modalCompletedDialogTargetConnected(ee) {
    const closeModal = getModal("modal_close_referral")
    const isOpen = !!closeModal && closeModal._element.classList.contains("show");
    if(isOpen) {
      // only open modal if close modal is open, indicate closing request
      closeModal.hide();
      getModal("modal_completed_referral").show();
    }
  }

  toggleOnHoldReminder(relativeReminder) {
    if(relativeReminder == 'Custom'){
      this.customSnoozeReminderTarget.classList.remove('d-none')
    }else{
      this.customSnoozeReminderTarget.classList.add('d-none')
      const date = getDateFromRelativeDate(relativeReminder)
      this.customSnoozeReminderTarget.querySelector('#snooze_reminder_date')._flatpickr.setDate(date)
    }
    this.onHoldReminderTarget.querySelector('.selected-date').innerText = relativeReminder
  }

  toggleTimelineText(event) {
    let container = event.currentTarget.closest(".nested-comment-content");
    if (container) {
      let noteTimeline = container.querySelector(".note-timeline");
      noteTimeline.classList.toggle("truncate");
      event.currentTarget.textContent =
        event.currentTarget.textContent.includes("Show More")
          ? "Show Less"
          : "Show More";
    }
  }

  initDatepicker() {
    const datepickerElement = $(this.datepickerTarget);
    const defaultDate = this.datepickerTarget.dataset.value

    flatpickr(datepickerElement, {
      defaultDate: defaultDate,
      allowInput: true,
      altInput: true,
      altFormat: "M j, Y",
      plugins: [
        FlatpickrShortcuts({
          button: [
            {
              label: "Clear",
            },
          ],
          onClick: (index) => {
            switch (index) {
              case 0:
                datepickerElement[0]._flatpickr.clear();
                datepickerElement[0]._flatpickr.close();
                break;
            }
          },
        }),
      ],
      onChange: this.checkDateTimeSelected.bind(this),
    });
  }

  populateTimepicker() {
    const timepickerElement = this.timepickerTarget;
    const increment = 15;
    timepickerElement.innerHTML = '';
    timepickerElement.innerHTML += `<option value="" selected>Select a time</option>`;

    for (let hour = 6; hour <= 18; hour++) {
      for (let minute = 0; minute < 60; minute += increment) {
        if (hour === 18 && minute > 0) {
            break;
        }
        const timeString = this.formatTime12Hour(hour, minute);
        timepickerElement.innerHTML += `<option value="${timeString}">${timeString}</option>`;
      }
    }
    timepickerElement.addEventListener('change', this.checkDateTimeSelected.bind(this));
  }

  saveDateTime() {
    this.submitBtnDateTimeTarget.disabled = true;
    const isUnscheduled = this.unscheduleCheckboxTarget.checked;
    const selectedRadio = this.appointmentTypeTarget.querySelector('input[name="appointment_type"]:checked');
    const appointmentType = selectedRadio ? selectedRadio.value : null;
    const referralId = this.datetimepickerTarget.dataset.referralDetailId;

    const appointmentDate = isUnscheduled ? null : this.datetimepickerTarget.value;

    if (appointmentType && (appointmentDate || isUnscheduled)) {
      this.updateAppointmentDateTime(appointmentDate, referralId, appointmentType);
    }
  }

  updateAppointmentDateTime(dateTimeString, referralId, appointmentStatus) {
    $.ajax({
      method: "PUT",
      url: `/referrals/${referralId}/update_appointment_date`,
      data: { appointment_date: dateTimeString, status: appointmentStatus},
      headers: {
        "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content"),
      },
      success: (data) => {
        window.location.reload();
      },
    });

    this.checkDateTimeSelected();
  }

  formatTime12Hour(hour, minute) {
    const period = hour < 12 ? "AM" : "PM";
    let adjustedHour = hour % 12;
    if (adjustedHour === 0) {
      adjustedHour = 12;
    }
    const hourString = adjustedHour.toString().padStart(2, '0');
    const minuteString = minute.toString().padStart(2, '0');
    return `${hourString}:${minuteString} ${period}`;
  }

  checkDateTimeSelected() {
    const selectedRadio = this.appointmentTypeTarget.querySelector('input[name="appointment_type"]:checked');
    const appointmentType = selectedRadio ? selectedRadio.value : null;
    const appointmentDateTime = this.datetimepickerTarget.value;
    const isUnscheduled = this.unscheduleCheckboxTarget?.checked;
    const submitButton = this.submitBtnDateTimeTarget;

    const canSubmit = appointmentType && (appointmentDateTime || isUnscheduled);

    if (canSubmit) {
      submitButton.classList.remove('btn-lock');
      submitButton.classList.add('btn-active');
    } else {
      submitButton.classList.remove('btn-active');
      submitButton.classList.add('btn-lock');
    }
  }

  dropdownStatusTargetConnected() {
    const referralStatus = this.dropdownStatusTarget.innerText.trim();

    if (referralStatus === "Completed") {
      this.sendAsvBtnTarget.classList.remove("d-none");
    } else {
      this.sendAsvBtnTarget.classList.add("d-none");
    }
  }

  closeReferral(e){
    this.closeReferralTarget.classList.add("btn-lock");
  }

  activateCloseReferral(e) {
    $('[data-referral-detail-target="closeReferral"]').removeClass("btn-lock")
  }

  toggleOffcanvasTimeline(event) {
    this.offcanvasTimelineTarget.style.display = 'block';
    this.offcanvasTimelineTarget.classList.add('offcanvas-open');
    this.offcanvasTimelineSidebarTarget.classList.add('d-none');
  }

  closeOffcanvasTimeline() {
    this.offcanvasTimelineTarget.classList.remove('offcanvas-open');
    this.offcanvasTimelineTarget.style.display = 'none';
    this.offcanvasTimelineSidebarTarget.classList.remove('d-none');
  }

  changeReferredProviderDropdownMenuText(e) {
    this.referredProviderDropdownMenuTarget.innerHTML = e.target.innerText;
  }

  disconnect() {
    document.removeEventListener("click", this.closeDropdowns.bind(this));
  }

  showDropdown(type) {
    type = typeof type == "string" ? type : type.target.dataset.type
    if (type === "location" && this.hasLocationDropdownTarget) {
      this.locationDropdownTarget.classList.remove("d-none");
      this.hideDropdown("provider");
    } else if (type === "provider" && this.hasProviderDropdownTarget) {
      this.providerDropdownTarget.classList.remove("d-none");
      this.hideDropdown("location");
    }
  }

  hideDropdown(type) {
    if (type === "location" && this.hasLocationDropdownTarget) {
      this.locationDropdownTarget.classList.add("d-none");
    } else if (type === "provider" && this.hasProviderDropdownTarget) {
      this.providerDropdownTarget.classList.add("d-none");
    }
  }

  filterList(event) {
    const type = event.currentTarget.dataset.type;
    const searchText = event.currentTarget.value ? event.currentTarget.value.toLowerCase() : "";
    const filterType = event.currentTarget.dataset.filterType;

    let items;
    if (type === "location" && filterType != "provider" && this.hasLocationDropdownItemsTarget) {
      items = this.locationDropdownItemsTarget.querySelectorAll("li");
    } else if (type === "provider" && this.hasProviderDropdownItemsTarget) {
      items = this.providerDropdownItemsTarget.querySelectorAll("li");
    } else if (filterType === 'provider'){
      this.filterReferredProvidersByLocation(event.currentTarget.dataset.id)
      return;
    } else {
      return;
    }

    items.forEach((item) => {
      const text = item.dataset.name ? item.dataset.name.toLowerCase() : "";
      item.style.display = text.includes(searchText) ? "block" : "none";
    });

    this.showDropdown(type);
  }

  selectItem(event) {
    if (event.target.tagName.toLowerCase() === "input" && event.target.type === "checkbox") {
      return;
    }

    const { id, name, type } = event.currentTarget.dataset;

    if (type === "location") {
      if (this.hasInputLocationTarget && this.hasHiddenInputLocationIdTarget) {
        this.inputLocationTarget.value = name;
        this.hiddenInputLocationIdTarget.value = id;
      }
    } else if (type === "provider") {
      if (this.hasInputProviderTarget && this.hasHiddenInputProviderIdTarget) {
        this.inputProviderTarget.value = name;
        this.hiddenInputProviderIdTarget.value = id;
      }
    }

    this.hideDropdown(type);
    if (type === "location") this.filterList(event)
  }

  closeDropdowns(event) {
    if (
      (this.hasInputLocationTarget && this.inputLocationTarget.contains(event.target)) ||
      (this.hasLocationDropdownTarget && this.locationDropdownTarget.contains(event.target)) ||
      (this.hasInputProviderTarget && this.inputProviderTarget.contains(event.target)) ||
      (this.hasProviderDropdownTarget && this.providerDropdownTarget.contains(event.target))
    ) {
      return;
    }

    if (this.hasLocationDropdownTarget) this.hideDropdown("location");
    if (this.hasProviderDropdownTarget) this.hideDropdown("provider");
  }

  checkForModalOpen() {
    if (new URLSearchParams(window.location.search).get('open_modal') === 'true') {
      this.openAssignLocationModal();
    }
  }

  openAssignLocationModal(e) {
    const assign_action = e ? e.currentTarget.dataset.assignAction : 'assign_provider_and_location'
    const modal = document.getElementById('modal_assign_location_provider');
    if (modal) {
      const bootstrapModal = new Modal(modal, {
        backdrop: false
      });
      bootstrapModal.show();
      if (this.hasHiddenInputAcceptReferralTarget){
        this.hiddenInputAcceptReferralTarget.value = assign_action == 'accept-referral';
      }
    }
  }

  openStatusChangeModal(e) {
    const actionType = e ? e.currentTarget.dataset.actionType : 'consultation'
    const noAction = e.currentTarget.dataset.noAction
    if (noAction == 'true' || noAction == true) return
    const modal = actionType == 'on_hold' ? '#modal_on_hold' : '#modal_schedule_appointment'
    
    if (modal == '#modal_schedule_appointment') {
      const radio = document.querySelector(`input[name="appointment_type"][value="${actionType}"]`);
      if (radio) radio.checked = true;
    }
    const bootstrapModal = new Modal(modal);
    bootstrapModal.show()
  }

  filterReferredProvidersByLocation(locationId) {
    const items = this.providerDropdownItemsTarget.querySelectorAll("li") || [];
    let hasSelected = false
    items.forEach((item) => {
      const locationIds = item.dataset.locationIds ? item.dataset.locationIds.split(",") : []
      const hasLocation = locationIds.includes(locationId)
      item.style.display = hasLocation ? "block" : "none";
      hasSelected = hasSelected || (hasLocation && this.hasInputProviderTarget && (this.inputProviderTarget.value == item.dataset.name))
    });
    if (!hasSelected) {
      if (this.hasInputProviderTarget)  this.inputProviderTarget.value = "";
      if (this.hasHiddenInputProviderIdTarget) this.hiddenInputProviderIdTarget.value = ""
    }
  }

  countCharacters(pointerEvent) {
    const count = pointerEvent.target.value.length;

    document.getElementById('CharacterCount').innerText = count + "/750";
  }

  initDatetimepicker() {
    const el = this.datetimepickerTarget;
    const rawValue = el.dataset.value;
    const defaultDate = rawValue ? new Date(rawValue) : null;

    flatpickr(el, {
      enableTime: true,
      dateFormat: "Y-m-d H:i",
      altInput: true,
      altFormat: "M j, Y h:i K",
      defaultDate: defaultDate,
      allowInput: true,
      time_24hr: false,
      onChange: this.checkDateTimeSelected.bind(this)
    });
  }

  hideNotice() {
    if (this.hasNoticeTarget) {
      this.noticeTarget.remove();
    }
  }

  toggleUnscheduled(event) {
    const checked = event.target.checked;

    const flatpickrInstance = this.datetimepickerTarget._flatpickr;
    const visibleInput = flatpickrInstance?.altInput || this.datetimepickerTarget;

    if (checked) {
      visibleInput.disabled = true;
      this.submitBtnDateTimeTarget.classList.remove('btn-lock');
      this.submitBtnDateTimeTarget.classList.add('btn-active');

      flatpickrInstance?.clear();
    } else {
      visibleInput.disabled = false;
      this.checkDateTimeSelected();
    }
  }
}
